<div class="lp-web-style-sheet-image-canvas-component" style="width: 100%; height: 100%">
  @let sprite = _stylesService[comp().sprite]();
  <app-style-sheet-sprite [sprite]="sprite?.container" [text]="sprite?.text" />
</div>
